module.exports = __webpack_public_path__ + "img/66078f7c-b2da-4232-9b72-06f236b18f68.854f5155.png";